export default {
    "pageTitle": "Stipes",
    "defaultTextSelectBox": "eligere ad valorem",
    "filterByCity": "nomen ab urbe filter",
    "filterByCompany": "filter a comitatu nomen eius",
    "sortBy": "digerere",
    "authorName": "auctor nominis",
    "cityName": "nomen civitatis",
    "companyName": "nomen corporationis"

}


// WEBPACK FOOTER //
// ./src/data/content.js